import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return <header className="site-header">
    <div className="container nav-wrap">
      <Link to="/" className="brand" onClick={() => setOpen(false)} aria-label="WB Tech Ventures home">
        <img src="/wbtechventureslogo.jpeg" width="42" height="42" alt="" />
        <span>WB Tech Ventures<span className="brand-caption">Independent software company</span></span>
      </Link>
      <button className="menu-toggle" aria-label={open ? 'Close navigation' : 'Open navigation'} aria-expanded={open} aria-controls="main-navigation" onClick={() => setOpen(!open)}>{open ? 'Close' : 'Menu'} <span aria-hidden="true">{open ? '×' : '+'}</span></button>
      <nav id="main-navigation" aria-label="Main navigation" className={open ? 'navigation is-open' : 'navigation'}>
        {[['/', 'Home'], ['/projects', 'Projects'], ['/about', 'About'], ['/contact', 'Contact']].map(([to, label]) => <NavLink key={to} to={to} end={to === '/'} className={({ isActive }) => `${isActive ? 'active ' : ''}${to === '/contact' ? 'nav-contact' : ''}`} onClick={() => setOpen(false)}>{label}{to === '/contact' && <span aria-hidden="true"> ↗</span>}</NavLink>)}
      </nav>
    </div>
  </header>;
}
